import {Help, Storage} from '@mui/icons-material';
import {Tooltip} from '@mui/material';
import Grid from '@mui/material/Grid';
import PropTypes from 'prop-types';

import ComplementaryInformation from '../ComplementaryInformation/ComplementaryInformation';
import UpdatedTablesTooltip from '../UpdatedTablesTooltip/UpdatedTablesTooltip';

const SuccessfulUpdateHistory = ({iconColor, tables}) => {
  const tablesUpdatedSuccessfully = tables.filter(t => t.status === 'Completed');
  const tablesNotUpdated = tables.filter(t => t.status !== 'Completed');

  const numberOfTables = tables.length;
  const numberOfTablesUpdated = tablesUpdatedSuccessfully?.length;

  return (
    <Grid item>
      <Grid container gap={0.5} alignItems="center">
        <Storage sx={{fontSize: 14, color: iconColor}} />
        <ComplementaryInformation>
          {numberOfTablesUpdated}/{numberOfTables} table{numberOfTablesUpdated > 1 ? 's' : ''} actualisée{numberOfTablesUpdated > 1 ? 's' : ''}
        </ComplementaryInformation>

        <Tooltip title={<UpdatedTablesTooltip tablesUpdatedSuccessfully={tablesUpdatedSuccessfully} tablesNotUpdated={tablesNotUpdated} />}>
          <Help sx={{fontSize: 15, cursor: 'pointer'}} />
        </Tooltip>
      </Grid>
    </Grid>
  );
};

SuccessfulUpdateHistory.propTypes = {
  iconColor: PropTypes.string.isRequired,
  tables: PropTypes.array.isRequired
};

export default SuccessfulUpdateHistory;
